// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import SellingCostsInput from '../selling-costs';

const SellingCostsInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <SellingCostsInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default SellingCostsInputWithAnalytics;
